<template>
  <b-modal v-model="showModal">
    <div class="card m-3">
      <div class="card-header card-header-title card-header-fixed">
        <h4>Select an image for this bookmark</h4>
      </div>

      <div class="card-content">
        <div class="columns is-mobile is-multiline is-vcentered">
          <div
            v-for="image in allImages"
            :key="image"
            class="column is-6"
            @click="changeImage(image)"
          >
            <b-image
              :src="image"
              class="bookmark-image"
              ratio="6by4"
            />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: 'SelectImage',
    props: ['allImages'],
    data: function() {
      return {
        showModal: false
      }
    },
    methods: {
      open() {
        this.showModal = true
      },
      changeImage(url) {
        this.$emit('changeImage', url)
        this.showModal = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .bookmark-image {
    min-height: 200px;
    height: 100%;
    border: 1px solid #e6e6e6;
    cursor: pointer;
  }

  .card-header-fixed {
    position: sticky;
    z-index: 1000;
    width: 100%;
    top: 0;
    background: #fff;
  }
</style>
